import axios from 'axios';
import { baseApiUrl, externalBackofficeApiUrl } from '../../utils';

const baseUrl = process.env.NODE_ENV === 'development' ? baseApiUrl.dev : baseApiUrl.prod;
const externalBackofficeUrl = process.env.NODE_ENV === 'development' ? externalBackofficeApiUrl.dev : externalBackofficeApiUrl.prod;

export const BaseClient = axios.create({
	baseURL: baseUrl,
	headers: {
		'Content-Type': 'application/json',
	},
});

BaseClient.interceptors.request.use((config) => {
	
	const token = sessionStorage.getItem('access_token') || '';

	if (token) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
});

export const BaseClientExternalBackOffice = axios.create({
	baseURL: externalBackofficeUrl,
	headers: {
		'Content-Type': 'application/json',
	},
});
